import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactMethods = ({ onWhatsAppClick }) => {
  const [copiedEmail, setCopiedEmail] = useState(false);

  const contactMethods = [
    {
      type: "primary",
      icon: "MessageCircle",
      title: "WhatsApp Expert Chat 1",
      subtitle: "Instant Gaming Consultation",
      description: "Connect directly with our gaming experts for personalized advice, game recommendations, and exclusive offers.",
      action: "Chat on WhatsApp",
      info: "+91 77030 77959",
      availability: "Online Now",
      responseTime: "< 2 minutes",
      color: "success",
      onClick: () => window.open('https://wa.me/917704070169', '_blank')
    },
    {
      type: "primary",
      icon: "MessageCircle",
      title: "WhatsApp Expert Chat 2",
      subtitle: "Instant Gaming Consultation",
      description: "Connect directly with our gaming experts for personalized advice, game recommendations, and exclusive offers.",
      action: "Chat on WhatsApp",
      info: "+91 77030 77952",
      availability: "Online Now",
      responseTime: "< 2 minutes",
      color: "success",
      onClick: () => window.open('https://wa.me/917704070169', '_blank')
    },
    {
      type: "secondary",
      icon: "Send",
      title: "Telegram Support",
      subtitle: "Alternative Messaging",
      description: "Prefer Telegram? Our support team is also available on Telegram for quick assistance and updates.",
      action: "Open Telegram Support",
      info: "@NITINSupport",
      availability: "Online",
      responseTime: "< 5 minutes",
      color: "primary",
      onClick: () => window.open('https://t.me/NITINSupport', '_blank')
    },
    {
      type: "secondary",
      icon: "Send",
      title: "Telegram Group",
      subtitle: "Join Our Community",
      description: "Join our official Telegram group to connect with other players and get community support.",
      action: "Join Telegram Group",
      info: "Group Link",
      availability: "Online",
      responseTime: "< 5 minutes",
      color: "primary",
      onClick: () => window.open('https://t.me/+wK_oOLQvUBo5ZWE9', '_blank')
    },
    {
      type: "secondary",
      icon: "Send",
      title: "Telegram Channel",
      subtitle: "Official Updates",
      description: "Subscribe to our Telegram channel for the latest news, updates, and announcements.",
      action: "Join Telegram Channel",
      info: "Channel Link",
      availability: "Online",
      responseTime: "< 5 minutes",
      color: "primary",
      onClick: () => window.open('https://t.me/+1iAesH3uLk83YTA1', '_blank')
    },
    {
      type: "tertiary",
      icon: "Mail",
      title: "Email Support",
      subtitle: "Detailed Inquiries",
      description: "For detailed queries, documentation, or formal communication, reach out via email.",
      action: "Copy Email",
      info: "support@nitinnonlinehub.com",
      availability: "24/7",
      responseTime: "< 4 hours",
      color: "accent",
      onClick: () => {
        navigator.clipboard?.writeText('support@nitinnonlinehub.com');
        setCopiedEmail(true);
        setTimeout(() => setCopiedEmail(false), 2000);
      }
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-gradient-royal mb-6">
            Multiple Ways to Connect
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
            Choose your preferred communication method. Our expert team is ready to assist you across all platforms.
          </p>
        </div>

        {/* Contact Methods Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {contactMethods?.map((method, index) => (
            <div 
              key={index}
              className={`relative bg-surface rounded-card shadow-subtle hover:shadow-royal transition-royal hover-lift ${
                method?.type === 'primary' ? 'lg:scale-105 border-2 border-golden' : ''
              }`}
            >
              {/* Priority Badge */}
              {method?.type === 'primary' && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                  <div className="bg-gradient-royal text-white px-4 py-1 rounded-full text-sm font-semibold shadow-royal">
                    Recommended
                  </div>
                </div>
              )}

              <div className="p-8">
                {/* Icon & Status */}
                <div className="flex items-center justify-between mb-6">
                  <div className={`w-16 h-16 rounded-card flex items-center justify-center ${
                    method?.type === 'primary' ? 'bg-gradient-royal shadow-royal' : 'bg-gradient-to-br from-primary/10 to-accent/10'
                  }`}>
                    <Icon 
                      name={method?.icon} 
                      size={32} 
                      color={method?.type === 'primary' ? 'white' : `var(--color-${method?.color})`}
                      strokeWidth={2}
                    />
                  </div>
                  
                  <div className="text-right">
                    <div className={`flex items-center space-x-2 text-sm font-medium ${
                      method?.availability === 'Online Now' ? 'text-success' : 'text-primary'
                    }`}>
                      <div className={`w-2 h-2 rounded-full ${
                        method?.availability === 'Online Now' ? 'bg-success animate-pulse' : 'bg-primary'
                      }`}></div>
                      <span>{method?.availability}</span>
                    </div>
                    <p className="text-xs text-text-muted mt-1">
                      Response: {method?.responseTime}
                    </p>
                  </div>
                </div>

                {/* Content */}
                <div className="mb-6">
                  <h3 className="text-xl font-heading font-bold text-text-primary mb-2">
                    {method?.title}
                  </h3>
                  <p className="text-sm font-medium text-primary mb-3">
                    {method?.subtitle}
                  </p>
                  <p className="text-text-secondary leading-relaxed mb-4">
                    {method?.description}
                  </p>
                  
                  {/* Contact Info */}
                  <div className="bg-muted rounded-button p-3 mb-6">
                    <p className="text-sm font-mono text-text-primary text-center">
                      {method?.info}
                    </p>
                  </div>
                </div>

                {/* Action Button */}
                <Button
                  variant={method?.type === 'primary' ? 'default' : 'outline'}
                  size="default"
                  onClick={method?.onClick}
                  iconName={method?.icon}
                  iconPosition="left"
                  fullWidth
                  className={method?.type === 'primary' ? 'bg-gradient-royal hover:shadow-glow' : ''}
                >
                  {method?.action === 'Copy Email' && copiedEmail ? 'Email Copied!' : method?.action}
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Contact Bar */}
        <div className="bg-gradient-to-r from-primary/5 via-accent/5 to-primary/5 rounded-card p-6 border border-golden">
          <div className="flex flex-col lg:flex-row items-center justify-between space-y-4 lg:space-y-0">
            <div className="text-center lg:text-left">
              <h3 className="text-xl font-heading font-bold text-text-primary mb-2">
                Need Immediate Assistance?
              </h3>
              <p className="text-text-secondary">
                Our gaming experts are standing by to help you right now.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4">
              <Button
                variant="default"
                size="lg"
                onClick={onWhatsAppClick}
                iconName="MessageCircle"
                iconPosition="left"
                className="bg-gradient-royal hover:shadow-glow animate-pulse-golden hover:animate-none"
              >
                WhatsApp Now
              </Button>
              
              <div className="flex items-center space-x-2 text-sm text-text-muted">
                <Icon name="Users" size={16} color="var(--color-success)" />
                <span>3 experts online</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;